module.exports = __webpack_public_path__ + "static/media/fab-qrcode-icon.a127c74d.svg";